var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rainy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rainy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.36,107.73H181.9c3.87,0,18.26-1.84,15.77-19.09-3.87-26.84-30.44-17.71-30.44-17.71s6-14.85-8-26.29c-18.26-14.94-32.65-2.49-32.65-2.49S122.41,22.5,93.63,24.44C62.86,26.51,63.74,49.89,63.74,49.89a20.34,20.34,0,0,0-24.63-1.66C24.6,57.23,28.6,70.1,28.6,70.1S6.73,67.89,2.87,85C-1.29,103.46,11.17,107.73,18.36,107.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.9,115.68c-4.57,11.21-9.34,11.48-9.34,19.85,0,11.21,18.68,11.21,18.68,0C44.23,127.17,39.46,126.89,34.9,115.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.06,115.68c-4.57,11.21-9.34,11.48-9.34,19.85,0,11.21,18.68,11.21,18.68,0C87.4,127.17,82.63,126.89,78.06,115.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121,115.68c-4.57,11.21-9.34,11.48-9.34,19.85,0,11.21,18.68,11.21,18.68,0C130.36,127.17,125.59,126.89,121,115.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.19,115.68c-4.57,11.21-9.34,11.48-9.34,19.85,0,11.21,18.68,11.21,18.68,0C173.53,127.17,168.76,126.89,164.19,115.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.82,147.44c-4.57,11.21-9.34,11.48-9.34,19.85,0,11.21,18.68,11.21,18.68,0C152.15,158.92,147.38,158.64,142.82,147.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.23,147.44c-4.57,11.21-9.34,11.48-9.34,19.85,0,11.21,18.68,11.21,18.68,0C108.57,158.92,103.8,158.64,99.23,147.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.48,147.44c-4.57,11.21-9.34,11.48-9.34,19.85,0,11.21,18.68,11.21,18.68,0C65.82,158.92,61,158.64,56.48,147.44Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainy);
export default __webpack_public_path__ + "static/media/rainy.5077709b9d2912eaf6c779ba2a0f3598.svg";
export { ForwardRef as ReactComponent };